import { render, staticRenderFns } from "./ScreenGroupEditModal.vue?vue&type=template&id=47bf9adc&"
import script from "./ScreenGroupEditModal.vue?vue&type=script&lang=js&"
export * from "./ScreenGroupEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports